import type { getUserSettingsOutput } from "@/api/custom_types";
import type { SettingsFormData } from "../Settings";

const toNullableNumber = (v: unknown): number | null => {
	if (v === null || v === undefined || v === "") return null;
	const n = Number(v);
	return Number.isFinite(n) ? n : null;
};

const toNullableScaledNumber = (v: unknown, divisor: number): number | null => {
	const n = toNullableNumber(v);
	return n === null ? n : n / divisor;
};

export const normalizeSettings = (
	data: getUserSettingsOutput,
): SettingsFormData => ({
	openForOrders: data.open_for_orders ?? true,
	fromOrderRange: toNullableScaledNumber(data.minimum_to_order, 1_000),
	toOrderRange: toNullableScaledNumber(data.maximum_to_order, 1_000),
	walletAddress: data.wallet ?? null,
	sellPrice: +data.default_sell_price,
	reservedBalance: toNullableScaledNumber(data.default_reserved_balance, 1_000),
	maxSender: data.maximum_sender_for_proxy ?? null,
	stockRatioPercentage: data.stock_ratio_percentage ?? null,
	globalSenderPriority: data.global_sender_priority ?? "MEDIUM",
	snipeCooldownHours: data.snipe_cooldown_hours ?? null,
});
